<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'base.filter' | translate }}
    v-card-content
      .cols-x
        .cols-x__2
          v-input.mb-3(
            disabled
            :label="'base.kg_per_day' | translate")
        .cols-x__2
          v-input.mb-3(
            disabled
            :label="'base.kg_per_day' | translate")
      .cols-x
        .cols-x__2
          v-input.mb-3(
            disabled
            :label="'base.price_from' | translate"
            :focus="true"
            v-model="filters.price_min")
        .cols-x__2
          v-input.mb-3(
            disabled
            :label="'base.price_to' | translate"
            v-model="filters.price_max")
      .cols-x
        .cols-x__2
          v-input.mb-3(
            disabled
            :label="'base.rest_days' | translate")
        .cols-x__2
          v-input.mb-3(
            disabled
            :label="'base.rest_days' | translate")
      .cols-x
        .cols-x__2
          v-input.mb-3(
            disabled
            :label="'base.stock_rest_from' | translate"
            v-model="filters.amount_min")
        .cols-x__2
          v-input.mb-3(
            disabled
            :label="'base.stock_rest_to' | translate"
            v-model="filters.amount_max")
      .cols-x
        .cols-x__2
          v-select(
            disabled
            :label="'base.delivery_type' | translate"
            :options="deliveryTypes"
            v-model="filters.delivery_type")
        .cols-x__2
          v-select(
            disabled
            :label="'base.ingredient' | translate"
            :options="ingredientsList"
            v-model="filters.ingredient")

    v-card-actions
      v-btn(
        @click="addFilters")
        | {{ 'reports.add_filters' | translate }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'FiltersModal',

  async mounted () {
    this.restoreFilters()
    const params = {
      farm: this.$route.params.farm_id
    }
    await this.loadIngredientsList(params)
  },

  data: () => ({
    filters: {
      price_min: null,
      price_max: null,
      amount_min: null,
      amount_max: null,
      ingredient: null,
      delivery_type: null
    },
    deliveryTypes: [
      { id: 'input', name: 'base.delivery' },
      { id: 'output', name: 'base.sale' }
    ]
  }),

  methods: {
    ...mapActions('ingredients', [
      'loadIngredientsList',
      'loadIngredients',
      'setFilters'
    ]),

    restoreFilters () {
      for (const key in this.ingredientFilters) {
        this.filters[key] = this.ingredientFilters[key]
      }
    },

    addFilters () {
      const filters = {}
      for (const key in this.filters) {
        if (this.filters[key] !== null) {
          filters[key] = this.filters[key]
        }
      }
      filters.farm = this.$route.params.farm_id
      this.setFilters(filters)
      this.$emit('close')
    }
  },

  computed: {
    ...mapGetters('ingredients', [
      'ingredientsList',
      'ingredientFilters'
    ])
  }
}
</script>
